import React from "react";
import { useNavigate } from "react-router-dom";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const boxStyle = {
  background: "#fff",
  borderRadius: 10,
  padding: "1.25rem",
  width: "min(520px, 92%)",
  boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
  textAlign: "center",
};

const titleStyle = { margin: 0, marginBottom: "0.5rem" };
const messageStyle = { margin: 0, marginBottom: "1rem", color: "#333" };
const btnRow = { display: "flex", gap: "0.5rem", justifyContent: "center" };
const primaryBtn = { background: "#2b6cb0", color: "#fff", border: "none", padding: "0.6rem 1rem", borderRadius: 6, cursor: "pointer" };
const ghostBtn = { background: "transparent", color: "#333", border: "1px solid #ddd", padding: "0.6rem 1rem", borderRadius: 6, cursor: "pointer" };

export default function AuthPromptModal({ open, onClose, message }) {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div style={overlayStyle} role="dialog" aria-modal="true">
      <div style={boxStyle}>
        <h3 style={titleStyle}>🚫 Please login or sign up</h3>
        <p style={messageStyle}>{message || "Please login or sign up to access this feature."}</p>

        <div style={btnRow}>
          <button
            style={primaryBtn}
            onClick={() => {
              onClose && onClose();
              navigate("/login");
            }}
          >
            Login
          </button>

          <button
            style={ghostBtn}
            onClick={() => {
              onClose && onClose();
              navigate("/signup");
            }}
          >
            Sign up
          </button>

          <button
            style={{ ...ghostBtn, marginLeft: 8 }}
            onClick={() => {
              onClose && onClose();
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

